import axios from 'axios';
import { getItem } from '@/helpers/storage';

axios.defaults.baseURL = 'https://easy-play.cc/';

axios.interceptors.request.use((config) => {
  const token = getItem('accessToken');
  const user = getItem('currentProfile');
  const authorizisationToken = token ? `${token}` : '';
  config.headers.Authorization = `Bearer ${authorizisationToken}`;
  if (user && user.profile_number) {
    config.headers['X-API-PROFILE'] = Number(user.profile_number);
  }
  return config;
});

export default axios;
